// extracted by mini-css-extract-plugin
module.exports = {"container":"StockWriteOffApprove_container__1v8cU","content":"StockWriteOffApprove_content__2NGGz","title":"StockWriteOffApprove_title__2R0no"};